export default "__VITE_ASSET__CnqqKkNn__"